export default __webpack_public_path__ + "static/media/IMAGE_3.241fd45d.png";